import { render, staticRenderFns } from "./JournalTab.vue?vue&type=template&id=5b052f8c&scoped=true&"
import script from "./JournalTab.vue?vue&type=script&lang=js&"
export * from "./JournalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b052f8c",
  null
  
)

export default component.exports